import { Box, styled } from '@mui/system';

export const QwireBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.white,
  fontWeight: 700,
  fontSize: 11,
  padding: 4,
  textTransform: 'uppercase',
  borderRadius: 4,
}));
